import {Routes, Route} from "react-router-dom";
import Layout from "@/components/Layout";
import AuthGuard from "@/components/AuthGuard";
import Home from "@/pages/Home";
import Rules from "@/pages/Rules";
import Feedback from "@/pages/Feedback";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Conduct from "@/pages/legal/Conduct";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import EmailVerification from "@/pages/auth/EmailVerification";
import VerifyEmailToken from "./pages/auth/VerifyEmailToken";
import Redirecting from "@/pages/auth/Redirecting";
import EnvLayout from "@/pages/env/EnvLayout";
import Overview from "@/pages/env/Overview";
import Settings from "@/pages/env/Settings";
import Characters from "@/pages/env/Characters";
import Sessions from "@/pages/env/Sessions";
import Titans from "@/pages/env/Titans";
import TitanManagement from "@/pages/env/TitanManagement";
import SessionManagement from "@/pages/env/SessionManagement";
import UserManagement from "@/pages/env/UserManagement";
import DMApprovals from "@/pages/env/DMApprovals";
import SystemLogs from "@/pages/env/SystemLogs";
import FeedbackManagement from "@/pages/env/FeedbackManagement";
import Calendar from "@/pages/env/Calendar";
import DMSignup from "@/pages/env/DMSignup";
import AdminConfig from "@/pages/env/AdminConfig";
import SessionLogs from "@/pages/env/SessionLogs";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="rules" element={<Rules />} />
        <Route path="feedback" element={<Feedback />} />
        <Route path="legal">
          <Route path="terms" element={<Terms />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="conduct" element={<Conduct />} />
        </Route>
        <Route path="auth">
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="email-verification" element={<EmailVerification />} />
          <Route path="redirecting" element={<Redirecting />} />
        </Route>
        <Route path="verify-email" element={<VerifyEmailToken />} />
        {/** Pretty URLs without /env prefix */}
        <Route element={<EnvLayout />}>
          <Route path="overview" element={<Overview />} />
          <Route path="settings" element={<Settings />} />
          <Route
            path="characters"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access your characters."
              >
                <Characters />
              </AuthGuard>
            }
          />
          <Route
            path="characters/:id"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access your characters."
              >
                <Characters />
              </AuthGuard>
            }
          />
          <Route
            path="sessions"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access sessions."
              >
                <Sessions />
              </AuthGuard>
            }
          />
          <Route
            path="titans"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access titans."
              >
                <Titans />
              </AuthGuard>
            }
          />
          <Route path="calendar" element={<Calendar />} />
          <Route
            path="session-logs"
            element={
              <AuthGuard
                requiredAnyRole={["dm", "moderator", "admin"]}
                denialMessage="Only Dungeon Masters and Administrators can view session logs."
              >
                <SessionLogs />
              </AuthGuard>
            }
          />
          <Route
            path="titanmanagement"
            element={
              <AuthGuard
                requiredAnyRole={["dm", "moderator", "admin"]}
                denialMessage="Only Dungeon Masters and Administrators can manage titans."
              >
                <TitanManagement />
              </AuthGuard>
            }
          />
          <Route
            path="sessionmanagement"
            element={
              <AuthGuard
                requiredAnyRole={["dm", "moderator", "admin"]}
                denialMessage="Only Dungeon Masters and Administrators can manage sessions."
              >
                <SessionManagement />
              </AuthGuard>
            }
          />
          <Route
            path="usermanagement"
            element={
              <AuthGuard
                requiredAnyRole={["admin"]}
                denialMessage="Only Administrators can manage users."
              >
                <UserManagement />
              </AuthGuard>
            }
          />
          <Route
            path="dm-approvals"
            element={
              <AuthGuard
                requiredAnyRole={["moderator", "admin"]}
                denialMessage="You need admin or moderator privileges to access this page."
              >
                <DMApprovals />
              </AuthGuard>
            }
          />
          <Route
            path="system-logs"
            element={
              <AuthGuard
                requiredAnyRole={["admin"]}
                denialMessage="Only Administrators can access system logs."
              >
                <SystemLogs />
              </AuthGuard>
            }
          />
          <Route
            path="admin-config"
            element={
              <AuthGuard
                requiredAnyRole={["admin"]}
                denialMessage="Only Administrators can access admin configuration."
              >
                <AdminConfig />
              </AuthGuard>
            }
          />
          <Route
            path="feedback-management"
            element={
              <AuthGuard
                requiredAnyRole={["moderator", "admin"]}
                denialMessage="You need admin or moderator privileges to access this page."
              >
                <FeedbackManagement />
              </AuthGuard>
            }
          />
          <Route path="dm-signup" element={<DMSignup />} />
        </Route>
        <Route path="env" element={<EnvLayout />}>
          <Route index element={<Overview />} />
          <Route path="overview" element={<Overview />} />
          <Route path="settings" element={<Settings />} />
          <Route
            path="characters"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access your characters."
              >
                <Characters />
              </AuthGuard>
            }
          />
          <Route
            path="characters/:id"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access your characters."
              >
                <Characters />
              </AuthGuard>
            }
          />
          <Route
            path="sessions"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access sessions."
              >
                <Sessions />
              </AuthGuard>
            }
          />
          <Route
            path="titans"
            element={
              <AuthGuard
                requiredAnyRole={["player", "dm", "moderator", "admin"]}
                denialMessage="You need to be a player to access titans."
              >
                <Titans />
              </AuthGuard>
            }
          />
          <Route path="calendar" element={<Calendar />} />
          <Route
            path="session-logs"
            element={
              <AuthGuard
                requiredAnyRole={["dm", "moderator", "admin"]}
                denialMessage="Only Dungeon Masters and Administrators can view session logs."
              >
                <SessionLogs />
              </AuthGuard>
            }
          />
          <Route
            path="titanmanagement"
            element={
              <AuthGuard
                requiredAnyRole={["dm", "moderator", "admin"]}
                denialMessage="Only Dungeon Masters and Administrators can manage titans."
              >
                <TitanManagement />
              </AuthGuard>
            }
          />
          <Route
            path="sessionmanagement"
            element={
              <AuthGuard
                requiredAnyRole={["dm", "moderator", "admin"]}
                denialMessage="Only Dungeon Masters and Administrators can manage sessions."
              >
                <SessionManagement />
              </AuthGuard>
            }
          />
          <Route
            path="usermanagement"
            element={
              <AuthGuard
                requiredAnyRole={["admin"]}
                denialMessage="Only Administrators can manage users."
              >
                <UserManagement />
              </AuthGuard>
            }
          />
          <Route
            path="dm-approvals"
            element={
              <AuthGuard
                requiredAnyRole={["moderator", "admin"]}
                denialMessage="You need admin or moderator privileges to access this page."
              >
                <DMApprovals />
              </AuthGuard>
            }
          />
          <Route
            path="system-logs"
            element={
              <AuthGuard
                requiredAnyRole={["admin"]}
                denialMessage="Only Administrators can access system logs."
              >
                <SystemLogs />
              </AuthGuard>
            }
          />
          <Route
            path="admin-config"
            element={
              <AuthGuard
                requiredAnyRole={["admin"]}
                denialMessage="Only Administrators can access admin configuration."
              >
                <AdminConfig />
              </AuthGuard>
            }
          />
          <Route
            path="feedback-management"
            element={
              <AuthGuard
                requiredAnyRole={["moderator", "admin"]}
                denialMessage="You need admin or moderator privileges to access this page."
              >
                <FeedbackManagement />
              </AuthGuard>
            }
          />
          <Route path="dm-signup" element={<DMSignup />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
